import { PrimeIcons } from "primereact/api";
import { Divider } from "primereact/divider";

import { labelLastUpdate, labelOwner } from "_constants";
import { formatDataSource } from "utils";
import { useAppSelector } from "store/store";
import { VisibilityChip } from "components/shared";

export const ProjectDetailPanelHeader = () => {
  const project = useAppSelector(
    (state) => state.gestioneProjectsSlice.currentProject
  );
  return (
    <div className="flex-container column gap-12">
      <h3 className="clamp-1">{project?.name}</h3>
      <div className="flex-container align-center gap-4">
        <VisibilityChip type={project?.type} />
        <Divider className="detail-panel-vertical-divider" layout="vertical" />
        <i className={PrimeIcons.USER} />
        <span className="text-base-regular">{labelOwner}</span>
        <span className="text-base-regular-semibold clamp-1 max-width-30 capitalize">
          {project?.createdBy}
        </span>
        <span className="text-base-regular">•</span>
        <i className={PrimeIcons.CALENDAR} />
        <span className="text-base-regular">{labelLastUpdate}</span>
        <span className="text-base-regular-semibold">
          {formatDataSource(project?.lastUpdate ?? "")}
        </span>
      </div>
    </div>
  );
};
